import { render, staticRenderFns } from "./PrettyImg.vue?vue&type=template&id=2a6efcee&"
import script from "./PrettyImg.vue?vue&type=script&lang=js&"
export * from "./PrettyImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports